export namespace SystemUserCommissionsConstants {
  export const Table = 'Table';
  export const CreateCommission = 'CreateCommission';
  export const UpdateCommission = 'UpdateCommission';
}
